import { render, staticRenderFns } from "./RequestNew.vue?vue&type=template&id=eb64b0e0&scoped=true&"
import script from "./RequestNew.vue?vue&type=script&lang=js&"
export * from "./RequestNew.vue?vue&type=script&lang=js&"
import style0 from "./RequestNew.vue?vue&type=style&index=0&id=eb64b0e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb64b0e0",
  null
  
)

export default component.exports